export const TEST_ID = 'holdStatusBadge';
